import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class AgentListDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.AgentSummary, Model.Bookings.Logic.ViewModels.AgentSummary, AgentSummary> {
    protected map(entity: Model.Bookings.Logic.ViewModels.AgentSummary): AgentSummary {
        return new AgentSummaryModel(entity);
    }

    public static make(context?: any): AgentListDataService {
        return new AgentListDataService(context, ctx => ctx.AgentSummaries);
    }
}

export class AgentSummaryModel extends EntityModel<Model.Bookings.Logic.ViewModels.AgentSummary, AgentSummary> implements AgentSummary {

    @property<AgentSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<AgentSummaryModel>(o => o.entity.name, (o, value) => o.entity.name = value)
    public name: string;

    @property<AgentSummaryModel>(o => o.entity.creditNumber, (o, value) => o.entity.creditNumber = value)
    public creditNumber?: number;

    @property<AgentSummaryModel>(o => o.entity.responsibleAgentId, (o, value) => o.entity.responsibleAgentId = value)
    public responsibleAgentId: number;

    @property<AgentSummaryModel>(o => o.entity.managedById, (o, value) => o.entity.managedById = value)
    public managedById: number;

    @property<AgentSummaryModel>(o => o.entity.managedByUserName, (o, value) => o.entity.managedByUserName = value)
    public managedByUserName: string;

    @property<AgentSummaryModel>(o => o.entity.hasChildren, (o, value) => o.entity.hasChildren = value)
    public hasChildren: boolean;
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/list/agent-list.data.ts